// zh.js
export default {
  stallQualification: {
    title: "攤位資料審核",
    gateHint: "所有攤位須補齊材料並審核通過後才可營業；既有訂單可繼續履約。",
    refresh: "重新載入",
    stallName: "攤位名稱",
    stallAddress: "攤位地址",
    nightMarket: "夜市 ID",
    status: "申請狀態",
    canOpen: "材料已審核通過",
    yes: "是",
    no: "否",
    draft: "草稿",
    pending: "待審核",
    approved: "已通過",
    rejected: "已駁回",
    notSubmitted: "未提交",
    unknown: "尚未載入",
    responsibleName: "負責人姓名",
    contactPhone: "聯絡電話",
    identityNumber: "負責人證件號碼",
    email: "電子郵箱",
    stallIntroduction: "攤位介紹",
    bankAccountName: "銀行帳戶戶名",
    bankName: "銀行名稱",
    bankAccountNo: "銀行帳號",
    bankProofImages: "銀行帳戶證明",
    businessRegistrationImages: "營業登記證明（如有）",
    directorScreenshotImages: "董監事資料查詢截圖（如有）",
    uboDeclarationImages: "實質受益人聲明書（如有）",
    identityImages: "負責人證件照片",
    stallImages: "攤位現場照片",
    foodRegistrationNumber: "食品業者登錄字號",
    foodRegistrationImages: "食品業者登錄證明",
    foodPolicyHint: "食品業者登錄字號及證明為選填。",
    saveDraft: "儲存草稿",
    submit: "提交審核",
    history: "申請歷史",
    version: "申請版本",
    submittedAt: "提交時間",
    reviewedAt: "審核時間",
    rejectReason: "駁回原因",
    actions: "操作",
    detail: "查看詳情",
    upload: "上傳圖片",
    uploadHint: "支援 JPEG / PNG，每張不超過 5 MB，每組最多 5 張。",
    remove: "移除",
    failed: "操作失敗，請稍後重試",
    materialsRequired: "請補齊負責人、證件、攤位照片及銀行帳戶資料",
    submitted: "已提交審核",
    saved: "草稿已儲存",
    storeId: "攤位 ID",
    search: "查詢",
    submittedBy: "提交人 ID",
    reviewedBy: "審核人 ID",
    reasonPlaceholder: "駁回時必須填寫原因，最多 500 字",
    approve: "審核通過",
    reject: "駁回",
    reasonRequired: "請填寫駁回原因",
    reviewed: "審核結果已儲存"
  },
	dongtai: {
		daishouli: '待受理',
		daichuchan: '待出餐',
		yichuchan: '已出餐',
		yiwancheng: '已完成',
		Canceled: '已取消',
		shouhou: '退款/售後',
		all: '全部',
		waisong: '外送',
		tangs: '堂食',
		ziqu: '自取',
	},
	loding: {
		language: 'zh-TW',
		lass: 'tw',
		cte: '恰恰吃商戶管理',
		lang: '選擇語言',
		username: '用戶名',
		pasd: '密碼',
		logng: '登入',
		txuse: '請填寫用戶名',
		txpad: '請填寫密碼'
	},
	route: {
		cte: '恰恰吃商戶',
		home: '首頁',
		mdguanli: '門店管理',
		mdlist: '門店清單',
		mdfenlei: '商品分類',
		spguanli: '商品管理',
		biaoti: '歡迎使用恰恰吃商戶平臺',
		degnlu: '登出',
		qttuicu: '確定要登出嗎?',
		tishi: '提示',
		tued: '確定',
		quxiao: '取消',
		yuiquangl: '優惠券管理',
		zxhd: '促銷活動管理',
		quanyi: '可用優惠券',
		ddpl: '訂單評論',
	},
	index: {
		newdd: '最新訂單',
		ddid: '訂單號',
		invoice: '發票',
		invoiceNone: '無',
		invoiceIssued: '已開票',
		invalidBtn: '作廢',
		invalidReason: '作廢原因',
		invalidOk: '已作廢',
		cretim: '下單時間',
		amount: '訂單金額',
		address: '配送地址',
		jvli: '配送距離',
		ddodr: '訂單商品',
		type: '訂單類型',
		tangs: '堂食',
		ziqu: '自取',
		waisong: '外送',
		collectPayment: '到付訂單',
		yes: '是',
		nos: '否',
		right: '操作',
		chak: '查看',
		jiedan: '接單',
		chucan: '出餐',
		tishi: '提示',
		tisiyu: '你確定要操作訂單嗎?',
		quxiao: '取消',
		qued: '確定',
		xiangq: '詳情',
		freight: '配送費',
		qishou: '接單騎手',
		foods: '訂單商品',
		guanbi: '關閉',
		shus: '商戶',
		sqsu: '騎手',
		user: '用戶',
		dpshu: '店鋪數',
		ddsour: '當日收入',
		dddingd: '當日訂單',
		zongsr: '總收入',
		zddlng: '總訂單量',
		ketixan: '可提現金額',
		beizu: '備註',
		cxhdxx: "促銷活動資訊",
		ptcxhd: "平臺促銷活動",
		sjcxhd: "商家促銷活動",
		jm: "減免",
		yhqxx: "優惠券資訊",
		ptyhq: "平臺優惠券",
		sjyhq: "商家優惠券",
		yhje: "優惠金額",
		none: "無",
		export: '匯出',
		jfsyqk: '積分使用情況',
		jfsysl: '使用積分數量',
		jfdkje: '折抵金額',
		startTime: '開始時間',
		endTime: '結束時間',
		payType: '支付方式',
		CashOnDelivery: '貨到付款',
		OfflineTransfer: '轉賬支付',
		OMG: 'OMG',
		LinePay: 'Line Pay',
		cash: '現金',
		wancheng: '完成',
	},
	mendian: {
		UBN: '統一編號',
		EnterUBN: '請輸入統一編號',
		UBNFormatError: '統一編號需為8位數字',
		home: '首頁',
		Management: '門店管理',
		StoreList: '门店列表',
		AddStore: '添加门店',
		logo: 'logo',
		StoreCover: '门店封面',
		StoreName: '门店名称',
		Startingprice: '起送价',
		openBusiness: '開始營業',
		windingUp: '結束營業',
		area: '所在地區',
		Telephone: '客服電話',
		operate: '操作',
		modify: '修改',
		delete: '删除',
		Enterstorename: '请输入店名称',
		address: '地址',
		InputAddress: '请输入店地址',
		coordinate: '坐标',
		Positioningobtaincoordinates: '请点击定位图标获取门店坐标',
		Storetype: '门店类型',
		Restaurant: '餐饮',
		Supermarket: '商超',
		Fillintheprice: '填写起送价格',
		Fillphonenumber: '填写客服电话',
		FillopenBusiness: '填寫開始營業時間，例：8:00',
		FillwindingUp: '填寫結束營業時間，例：18:00',
		classification: '分类',
		Pleaseselect: '请选择',
		ServiceType: '服务类型',
		Fooddelivery: '美食外送',
		Dinein: '堂食',
		Selfpickuptakeout: '外卖自取',
		Summericedrink: '夏日冰饮',
		Exquisiteafternoontea: '精致下午茶',
		state: '状态',
		trade: '营业',
		close: '打烊',
		determine: '确定',
		cancellation: '取消',
		selectaddress: '选择地址',
		Covercannotempty: '门店封面不能为空',
		Namecannotempty: '门店名称不能为空',
		Addresscannotempty: '门店地址不能为空',
		Coordinatescannotempty: '坐标不能为空',
		openBusinesscannotempty: '開始營業時間不能為空',
		windingUpcannotempty: '結束營業時間不能為空',
		Classifiedmandatory: '分类为必选项',
		Selectservicetype: '至少要选择一个服务类型',
		prompt: '提示',
		youwanttodeleteit: '你确定要删除此门店吗?',
		successful: '删除成功',
		Deletefailed: '失败，请重试',
		undelete: '已取消删除',
		ModifyStore: '修改门店',
		Selectmapobtainaddress: '请点选地图获取地址',
		ItcanonlyJPG: '上传头像图片只能是 JPG 格式!',
		Cannotexceed: '上传头像图片大小不能超过 2MB!',
		SearchAddress: '搜索地址',
		Pleasekeywords: '请输入关键字',
		currentlocation: '当前位置',
		openingtime: '營業時間',
		addTime: '新增时间段',
		zssjd: '请至少添加一个营业时间段',
		mgsjd: '每个时间段都需填写开始和结束时间',
		Monday: '星期一',
		Tuesday: '星期二',
		Wednesday: '星期三',
		Thursday: '星期四',
		Friday: '星期五',
		Saturday: '星期六',
		Sunday: '星期日',
		noTimeSlotWarning: '請先添加時間段再開啟該天',

		Selectbusinessday: '批次設定',
		businessday: '營業天',
		Enteropeningtime: '請新增營業時間',
		Enterbusinessday: '請選擇營業天',
		menuPhoto: '菜單照片',
		menuPhoto2: '請上傳菜單照片'
	},
	fenlei: {
		home: '首页',
		Management: '门店管理',
		CATEGORY: '商品分类',
		Addcategory: '添加商品分类',
		Classiname: '分类名称',
		operate: '操作',
		modify: '修改',
		delete: '删除',
		Plearname: '请输分类名称',
		determine: '确定',
		cancellation: '取消',
		Classifyempty: '分类名不能为空',
		successfully: '提交成功!',
		Modifyclass: '修改分类',
		prompt: '提示',
		DeleteCategory: '你确定要删除此分类吗?',
		successful: '删除成功',
		Deletefailed: '失败，请重试',
		undelete: '已取消删除',
		id: 'id',
		sodi: '請輸入排序id，數位越大越靠前'
	},
	imageCrop: {
		title: '裁切圖片',
		hint: '拖動裁切框調整位置，拖動右下角調整大小（正方形）',
		cancel: '取消',
		confirm: '確認裁切並上傳',
		invalidType: '請選擇圖片檔案',
		tooLarge: '上傳圖片大小不能超過 {size} MB',
		readFailed: '圖片讀取失敗，請重新選擇',
		cropFailed: '圖片裁切失敗，請重試',
		uploadFailed: '圖片上傳失敗',
		networkFailed: '圖片上傳失敗，請檢查網路後重試'
	},
	foots: {
		home: '首页',
		Management: '门店管理',
		Commodityfood: '商品管理',
		classification: '分类',
		addproduct: '添加商品',
		Tradename: '商品名称',
		Commoditypicture: '商品图片',
		commodityprice: '商品价格',
		illustrate: '说明',
		operate: '操作',
		modify: '修改',
		delete: '删除',
		Enterproductname: '请输入商品名称',
		Enterproductprice: '请输入商品价格',
		Attributes: '商品属性',
		AddType: '添加类型',
		EditType: '编辑类型',
		Radio: '单选',
		multiplechoice: '多选',
		optional: '可选',
		required: '必选',
		Introduction: '商品介绍',
		EnterIntroduction: '请输入商品介绍',
		Dorecommendit: '是否推荐',
		Productsorting: '商品排序',
		Anynumber: '填任何数值,值大排在前',
		determine: '确定',
		cancellation: '取消',
		typename: '类型名称',
		InputMerchantType: '请输入商品类型',
		Multiplechoices: '是否多选',
		Isitmandatory: '是否必选',
		Addspecifications: '添加规格',
		Addspecifications2: '编辑规格',
		formname: '规格名称',
		Entercationname: '请输入规格名称',
		Specificationprice: '规格价格',
		Enterandprices: '请输入规格价格',
		description: '规格说明',
		Entercationiption: '请输入规格说明',
		Imagebeempty: '图片不能为空',
		Namebeempty: '名称不能为空',
		Pricebeempty: '价格不能为空',
		Thenamebeempty: '规格名不能为空',
		Typenamebeempty: '类型名不能为空',
		prompt: '提示',
		Confirmdeletion: '你确定要删除商品类型吗?',
		Unabletodelete: '此类型存在规格,无法删除',
		DeleteSpecification: '你确定要删除商品规格吗?',
		Modifyproduct: '修改商品',
		Deletethisproduct: '你确定要删除此商品吗?',
		successful: '删除成功',
		Deletefailed: '失败，请重试',
		undelete: '已取消删除',
		ItcanonlyJPG: '上传头像图片只能是 JPG 格式!',
		Cannotexceed: '上传头像图片大小不能超过 2MB!',
		search: '查詢',
		reset: '重設',
		AddCategoryFirst: '請先添加商品分類再添加商品',
		AddCategoryFirst2: '請先添加門店再添加商品分類',
	},
	cuxiao: {
		home: '首頁',
		yuiquangl: '優惠券管理',
		zxhd: '促銷活動管理',
		AddCX: '新增',
		hdmc: '活動名稱',
		hdmcms: '請輸入促銷活動名稱',
		hdhb: '活動海報',
		qmfs: '減免方式',
		qmyf: '運費',
		ddjdz: '訂單',
		ddjdk: '商品',
		qmz: '減免值',
		qmzsm: '選免運費可留空，如選打折如7折請填0.7，如選抵扣1000請填1000',
		sytj: '使用條件',
		sytjsm: '留空為無任何使用條件，如填1000為訂單金額滿1000可用',
		salesFund: '可用次數',
		salesFundsm: '留空為無限使用，如填1為此活動每個用戶只能使用一次',
		endTime: '結束日期',
		endTimesm: '請選擇活動結束日期',
		salesState: '活動狀態',
		salesStateKq: '開啟',
		salesStateTy: '停用',
		illustrate: '活動說明',
		illustratesm: '請輸入內容',
		jsrq: '結束日期',
		hdzt: '活動狀態',
		operate: '操作',
		modify: '修改',
		delete: '刪除',
		hdmcEpty: '活動名稱不能空白',
		qmfsEmty: '減免方式為必選',
		endTimeEmty: "結束日期為必選",
		salesStateEmty: "活動狀態為必選",
		salesReductionEmty: '減免值為必填欄位',
		salesReduction0: '選擇訂單/商品優惠時，減免值必須大於0',
		delSm: '是否確認刪除此紀錄？',
		ItcanonlyJPG: '上傳圖片只能是 JPG 格式！',
		Cannotexceed: '上傳圖片大小不能超過 2MB！',
		bnxg: '此促銷活動已有用戶參與，僅可修改狀態，無法變更其他核心參數',
	},
	quanyi: {
		kyyhq: '可用優惠券',
		add: '新增',
		yhmc: '優惠券名稱',
		yhfs: '優惠方式',
		sm: '說明',
		sytj: '使用條件',
		zt: '狀態',
		qy: '啟用',
		gb: '關閉',
		yhqlx1: '運費',
		yhqlx2: '訂單',
		yhqlx3: '商品',
		yhqlx4: '減免個別商品',
		total: '優惠券總數',
		creatTime: '建立時間',
		sryhmc: '請輸入優惠券名稱',
		yhnum: '優惠值',
		sryhnum: '免運費請填0，如選擇折扣（例如7折請填0.7），如選擇折抵1000請填1000',
		yhmnum0: '選擇訂單、商品值必須大於0',
		srtotal: '請輸入優惠券總數',
		lqxz: '每人可領取數量',
		srlqxz: '請輸入每人可領取的數量',
		validity: "有效期限（天）",
		srvalidity: '請輸入有效期',
		shuoming: '說明',
		srshuoming: '請輸入說明',
		tiaojian: '使用條件',
		srtiaojian: '請輸入使用條件，0為無門檻，大於0為消費滿額可用',
		nameEpty: '優惠券名稱不能空白',
		yhfangsEmpty: '請選擇優惠方式',
		yhnumEmty: '優惠值不能空白',
		totalEmty: '優惠券總數不能空白',
		lqxzEmty: '每人可領取數量不能空白',
		validityEmty: '有效天數不能空白',
		stateEmty: '請選擇狀態',
		xcsp: '選擇商品',
		qxcsp: '請選擇商品',
		md: "門店：",
		xcmd: "選擇門店",
		spfl: '商品分類：',
		spmc: '商品名稱：',
		cx: '查詢',
		tp: '圖片',
		jg: '價格',
		qx: '取消',
		qd: '確定',
		ItcanonlyJPG: '上傳圖片只能是 JPG 格式！',
		Cannotexceed: '上傳圖片大小不能超過 2MB！',
		bnxg: '本優惠券已有用戶領取，僅能修改狀態，無法變更其他核心欄位',
		claimedCount: '已領取數量',
	},
	review: {
		ddid: '訂單id',
		srddid: '請輸入訂單id',
		plsj: '評論時間',
		cz: '操作',
		sc: '刪除',
		ck: '查看',
		yhid: '用戶id',
		pf: '評分',
		plnr: '評論內容',
		sfnm: '是否匿名',
		yes: '是',
		no: '否',
		pltp: '評論圖片',
		ddpl: '訂單評論',
	},
	Aside: {
		text1: "攤位管理",
		text2: "攤位列表",
		selfDeliverySettings: '自配送設定',
		text3: "餐桌管理",
		text4: "餐桌碼管理",
		text5: "財務管理",
		text6: "帳單管理"
	},
	TableQRCode: {
		text1: '類型',
		text2: '全部',
		text3: '私用碼',
		text4: '公用碼',
		text5: '狀態',
		text6: '啟用',
		text7: '停用',
		text8: '查詢',
		text9: '新增餐桌碼',
		text10: '桌號',
		text11: '停用',
		text12: '所屬門店/攤位',
		text13: '使用狀態',
		text14: '空閒',
		text15: '使用中',
		text16: '啟用狀態',
		text17: '建立時間',
		text18: '操作',
		text19: '查看二維碼',
		text20: '編輯',
		text21: '刪除',
		text22: '桌號',
		text23: '請輸入桌號，例如 A01',
		text24: '請選擇門店/攤位',
		text25: '備註',
		text26: '請輸入備註',
		text27: '取消',
		text28: '確定',
		text29: '選擇門店/攤位',
		text30: '搜尋名稱/地址',
		text31: '門店/攤位名稱',
		text32: '地址',
		text33: '電話',
		text34: '餐桌二維碼',
		text35: '桌號：',
		text36: '載入中...',
		text37: '關閉',
		text38: '下載',
		text39: '請輸入桌號',
		text40: '請選擇類型',
		text41: '請選擇攤位',
		text42: '取得清單失敗',
		text43: '編輯餐桌碼',
		text44: '更新成功',
		text45: '更新失敗',
		text46: '建立成功',
		text47: '建立失敗',
		text48: '確認刪除此餐桌碼？',
		text49: '提示',
		text50: '刪除成功',
		text51: '刪除失敗',
		text52: '操作成功',
		text53: '操作失敗',
		text54: '取得二維碼失敗',
		text55: '訂單',
		text56: '餐桌訂單 - ',
		text57: '訂單狀態',
		text58: '待處理',
		text59: '進行中',
		text60: '已完成/已關閉',
		text61: '訂單號',
		text62: '金額',
		text63: '出餐狀態',
		text64: '下單時間',
		text65: '已出餐',
		text66: '未出餐',
		text67: '已付款',
		text68: '已接單',
		text69: '配送中',
		text70: '已送達',
		text71: '已取消',
		text72: '退款中',
		text73: '已退款',
		text74: '退款拒絕',
		text75: '已評價',
		text76: '未知',
		text77: '取得訂單失敗',

		text78: '待接單',
		text79: '製作中',
		text80: '備餐完成',
		text81: '已完成',
		text82: '備註',
		text83: '首頁',
		text84: '餐桌碼管理',
	},
	StallManage: {
		text1: '建立攤位',
		text2: '攤位名稱',
		text3: '地址',
		text4: '電話',
		text5: '簡介',
		text6: '建立時間',
		text7: '操作',
		text8: '管理攤位主',
		text9: '編輯',
		text10: '攤位名稱',
		text11: '請輸入攤位名稱',
		text12: '請輸入地址',
		text13: '請輸入聯絡電話',
		text14: '請輸入簡介',
		text15: '取消',
		text16: '確定',
		text17: '攤位主管理',
		text18: '新增攤位主',
		text19: '暱稱',
		text20: '手機號碼',
		text21: '狀態',
		text22: '正常',
		text23: '停用',
		text24: '啟用',
		text25: '刪除',
		text26: '請輸入手機號碼',
		text27: '密碼',
		text28: '請輸入密碼',
		text29: '暱稱',
		text30: '請輸入暱稱',
		text31: '操作失敗',
		text32: '取得攤位列表失敗',
		text33: '建立攤位',
		text34: '編輯攤位',
		text35: '操作成功',
		text36: '操作失敗',
		text37: '新增成功',
		text38: '新增失敗',
		text39: '已停用',
		text40: '已啟用',
		text41: '確認刪除此攤位主？',
		text42: '提示',
		text43: '已刪除',
		text44: '刪除失敗',
		text45: '請輸入使用者名稱',
		ownerPassword: '密碼',
		editOwnerTitle: '編輯攤位主',
		editOwnerPasswordKeep: '不修改密碼請留空',
	},
	tableQrcode: {
		orderBtn: '訂單',
		orderDialogTitle: '餐桌訂單 - ',
		orderStatus: '訂單狀態',
		orderAll: '全部',
		orderPending: '待處理',
		orderInProgress: '進行中',
		orderCompleted: '已完成/已關閉',
		orderNo: '訂單號',
		orderAmount: '金額',
		orderState: '訂單狀態',
		diningStatus: '出餐狀態',
		orderTime: '下單時間',
		diningDone: '已出餐',
		diningNotDone: '未出餐',
		state0: '待處理',
		state1: '已付款',
		state2: '已接單',
		state3: '配送中',
		state4: '已送達',
		state6: '已取消',
		state7: '退款中',
		state8: '已退款',
		state9: '退款拒絕',
		state11: '已評價',
		stateUnknown: '未知',
		getOrderFailed: '獲取訂單失敗',
	}
	,
	promoMenu: {
		title: '營銷管理',
		activity: '促銷活動',
		coupon: '優惠券管理'
	},
	promoActivity: {
		home: '首頁',
		marketing: '營銷管理',
		title: '促銷活動',
		all: '全部',
		notStarted: '未開始',
		ongoing: '進行中',
		ended: '已結束',
		addActivity: '新增活動',
		activityName: '活動名稱',
		activityType: '活動類型',
		typeManjian: '滿減',
		typeZhekou: '折扣商品',
		typeHalfPrice: '第二份半價',
		typeNewUser: '新客立減',
		status: '狀態',
		startTime: '開始時間',
		endTime: '結束時間',
		operate: '操作',
		endBtn: '結束',
		tabManjian: '滿減活動',
		pleaseInputName: '請輸入活動名稱',
		activityTime: '活動時間',
		ruleTiers: '規則檔位',
		full: '滿',
		fullAmount: '金額',
		reduce: '減',
		reduceAmount: '減免金額',
		yuan: '元',
		deleteTier: '刪除',
		addTier: '添加檔位',
		tabZhekou: '折扣商品',
		discountRate: '折扣率',
		productName: '商品名稱',
		productPrice: '價格',
		remove: '移除',
		addProduct: '添加商品',
		tabHalfPrice: '第二份半價',
		productImage: '圖片',
		selectProduct: '選擇商品',
		tabNewUser: '新客立減',
		save: '保存',
		cancel: '取消',
		category: '商品分類',
		selectCategory: '選擇分類',
		keyword: '關鍵詞',
		search: '搜索',
		add: '添加',
		endConfirm: '確認結束該活動？結束後不可恢復。',
		prompt: '提示',
		confirm: '確定',
		productExists: '該商品已存在',
		pleaseSelectTime: '請選擇活動時間',
		pleaseCompleteRules: '請完善滿減規則',
		pleaseCompleteDiscount: '請輸入折扣率',
		pleaseSelectProducts: '請選擇商品',
		pleaseInputReduce: '請輸入減免金額',
		addSuccess: '新增成功',
		operateSuccess: '操作成功',
		operateFail: '操作失敗',
		editBtn: '編輯',
		deleteBtn: '刪除',
		editActivity: '編輯活動',
		createActivity: '新增活動',
		deleteConfirm: '確認刪除該活動？刪除後不可恢復。',
		editSuccess: '修改成功',
		deleteSuccess: '刪除成功',
		alreadyAdded: '已添加',
		discountedPrice: '折後價',
		originalPrice: '原價',
		addDiscountProduct: '添加折扣商品',
		productAlreadyAdded: '商品已添加，請勿重複選擇',
		discountRateRange: '折扣率範圍10%-99%',
		pleaseSelectProduct: '請先選擇商品'
	},
	couponBatch: {
		pageTitle: '優惠券管理', createBtn: '新增優惠券', offShelfBtn: '下架',
		offShelfConfirm: '確認下架該優惠券？已領取的券仍可使用。', couponName: '券名稱',
		couponType: '券類型', totalCount: '發放總量', remainCount: '剩餘', receivedCount: '已領取',
		validDays: '有效天數', validDaysUnit: '天（領取後計算）', receiveTime: '領取時間',
		status: '狀態', statusAll: '全部', statusNotStarted: '未開始', statusActive: '進行中',
		statusEnded: '已結束', statusOffShelf: '已下架', typeManjian: '滿減券', typeProduct: '商品券',
		mutexLabel: '疊加屬性', mutexShare: '同享券（可與促銷疊加）', mutexExclusive: '互斥券（不可與促銷疊加）',
		threshold: '使用門檻', thresholdUnit: '元', amount: '減免金額', amountUnit: '元',
		selectProduct: '選擇商品', discountRate: '折扣率', discountRateUnit: '%（如70表示7折）',
		saveBtn: '保存', cancelBtn: '取消', storeLabel: '門店', timeRange: '領取時間',
		nameRequired: '請輸入券名稱', timeRequired: '請選擇領取時間',
		totalRequired: '請輸入發放總量', validDaysRequired: '請輸入有效天數', amountRequired: '請輸入金額',
		marketing: '行銷管理',
		startTime: '領取開始時間',
		endTime: '領取結束時間',
		days: '天',
		offShelfSuccess: '下架成功',
		offShelfFail: '下架失敗',
		couponNamePlaceholder: '請輸入券名稱',
		selectStore: '選擇門店',
		typeRequired: '請選擇券類型',
		storeRequired: '請選擇門店',
		thresholdRequired: '請輸入使用門檻',
		discountRequired: '請輸入折扣率',
		productRequired: '請選擇商品',
		addSuccess: '新增成功',
		addFail: '新增失敗',
		category: '商品分類',
		selectCategory: '選擇分類',
		keyword: '搜尋',
		productName: '商品名稱',
		search: '查詢',
		image: '圖片',
		price: '價格',
		add: '添加',
		editBtn: '編輯',
		deleteBtn: '刪除',
		editCoupon: '編輯優惠券',
		createCoupon: '新增優惠券',
		deleteConfirm: '確認刪除該優惠券？刪除後不可恢復。',
		typeFreeDelivery: '免配送費券',
		deleteSuccess: '刪除成功',
		deleteFail: '刪除失敗',
		editSuccess: '修改成功',
		editFail: '修改失敗',
		remove: '移除',
		productExists: '商品已添加，请勿重複添加',
		alreadyAdded: '已添加'
	},

	"foots": {
		"home": "首頁",
		"Management": "門店管理",
		"Commodityfood": "商品管理",
		"classification": "分類",
		"addproduct": "新增商品",
		"Tradename": "商品名稱",
		"Commoditypicture": "商品圖片",
		"commodityprice": "商品價格",
		"illustrate": "說明",
		"operate": "操作",
		"modify": "修改",
		"delete": "刪除",
		"Enterproductname": "請輸入商品名稱",
		"Enterproductprice": "請輸入商品價格",
		"Attributes": "商品屬性",
		"AddType": "新增類型",
		"Radio": "單選",
		"multiplechoice": "多選",
		"optional": "可選",
		"required": "必選",
		"Introduction": "商品介紹",
		"EnterIntroduction": "請輸入商品介紹",
		"Dorecommendit": "是否推薦",
		"Productsorting": "商品排序",
		"Anynumber": "填任何數值，值大排在前",
		"determine": "確定",
		"cancellation": "取消",
		"typename": "類型名稱",
		"InputMerchantType": "請輸入商品類型",
		"Multiplechoices": "是否多選",
		"Isitmandatory": "是否必選",
		"Addspecifications": "新增規格",
		"formname": "規格名稱",
		"Entercationname": "請輸入規格名稱",
		"Specificationprice": "規格價格",
		"Enterandprices": "請輸入規格價格",
		"description": "規格說明",
		"Entercationiption": "請輸入規格說明",
		"Imagebeempty": "圖片不能為空",
		"Namebeempty": "名稱不能為空",
		"Pricebeempty": "價格不能為空",
		"Thenamebeempty": "規格名不能為空",
		"Typenamebeempty": "類型名不能為空",
		"prompt": "提示",
		"Confirmdeletion": "你確定要刪除商品類型嗎？",
		"Unabletodelete": "此類型存在規格，無法刪除",
		"DeleteSpecification": "你確定要刪除商品規格嗎？",
		"Modifyproduct": "修改商品",
		"Deletethisproduct": "你確定要刪除此商品嗎？",
		"successful": "刪除成功",
		"Deletefailed": "失敗，請重試",
		"undelete": "已取消刪除",
		"ItcanonlyJPG": "上傳頭像圖片只能是 JPG 格式！",
		"Cannotexceed": "上傳頭像圖片大小不能超過 2MB！",
		"search": "查詢",
		"reset": "重設",
		"sellingTime": "販售時間",
		"wholeDay": "整天",
		"wholeDayDesc": "開啟後商品將按照店面營業時間販售",
		"startTime": "開始時間",
		"endTime": "結束時間",
		"addTimeSlot": "新增時段",
		"pleaseSetSellingTime": "請設定販售時間",
		"enabledDaysMustSetTimeSlots": "啟用天數必須設定時段",
		"timeSlotsMustBeComplete": "時段必須填寫完整",
		"pleaseAddTimeSlotsFirst": "請先新增時段再開啟該天",
		"Monday": "星期一",
		"Tuesday": "星期二",
		"Wednesday": "星期三",
		"Thursday": "星期四",
		"Friday": "星期五",
		"Saturday": "星期六",
		"Sunday": "星期日"
	},
	"subaccount": {
		"menu": "分管帳號",
		"title": "分管帳號管理",
		"description": "為一個帳號分配多個負責店鋪，帳號無需切換目前店鋪。",
		"create": "新增分管帳號",
		"name": "姓名",
		"phone": "手機號碼",
		"stores": "負責店鋪",
		"noStores": "暫無負責店鋪",
		"accountStatus": "帳號狀態",
		"ownerEnabled": "主帳號已啟用",
		"ownerDisabled": "主帳號已停用",
		"platformEnabled": "平台正常",
		"platformDisabled": "平台已停用",
		"online": "在線狀態",
		"onlineYes": "在線",
		"onlineNo": "離線",
		"lastLogin": "最近登入",
		"actions": "操作",
		"edit": "編輯",
		"resetPassword": "重設密碼",
		"disableOwner": "停用",
		"enableOwner": "啟用",
		"editTitle": "編輯分管帳號",
		"createTitle": "新增分管帳號",
		"password": "密碼",
		"namePlaceholder": "請輸入姓名",
		"phonePlaceholder": "請輸入登入手機號碼",
		"passwordPlaceholder": "請輸入密碼",
		"storePlaceholder": "請選擇負責店鋪",
		"platformDisabledHint": "該帳號已被平台停用，主帳號啟用不會解除平台限制。",
		"cancel": "取消",
		"save": "儲存",
		"nameRequired": "請輸入姓名",
		"phoneRequired": "請輸入手機號碼",
		"passwordRequired": "請輸入密碼",
		"storeRequired": "請至少選擇一家店鋪",
		"saved": "儲存成功",
		"resetPasswordTitle": "重設分管帳號密碼",
		"newPassword": "新密碼",
		"confirmReset": "確認重設",
		"passwordReset": "密碼已重設，原登入工作階段已失效",
		"ownerEnabledResult": "已設為主帳號啟用",
		"ownerDisabledResult": "已設為主帳號停用",
		"platformStillDisabled": "平台停用狀態仍然有效"
	},
	"spec": {
		"spec": "商品規格",
		"addSpec": "新增規格",
		"specCategory": "規格類型",
		"specCategoryEmpty": "規格類型不能為空",
		"isOpen": "是否啟用",
		"detail": "規格明細",
		"addDetail": "新增明細",
		"editDetail": "編輯明細",
		"detailEmpt": "請新增規格明細",
		"modifySpec": "修改規格",
		"tryAgain": "儲存失敗，請重試",
		"excuteSuccess": "執行成功",
		"excuteFail": "執行失敗，請重試",
		"openSpec": "啟用",
		"atLeastOneDetailEnabled": "規格啟用時，至少需要啟用一項明細"
	},
	menuCopy: {
		entry: '從其他門店複製',
		title: '複製商品',
		description: '目前門店是目標門店。請選擇來源門店，系統會先預覽分類與商品差異。',
		targetStore: '目標門店',
		sourceStore: '來源門店',
		selectSource: '請選擇來源門店',
		addedCategories: '新增分類',
		mergedCategories: '合併分類',
		addedProducts: '新增商品',
		identicalProducts: '一致略過',
		differentProducts: '差異商品',
		alreadySynced: '兩家門店的菜單已經一致，無需複製。',
		differenceDetails: '差異明細',
		changedField: '差異欄位',
		targetValue: '本店目前值',
		sourceValue: '來源店值',
		conflictStrategy: '差異處理',
		keepTarget: '保留本店版本',
		overwriteTarget: '用來源店版本覆蓋',
		overwriteWarning: '覆蓋只更新商品內容與規格關聯，不改變本店商品的上下架及審核狀態。',
		cancel: '取消',
		confirm: '確認複製',
		operationFailed: '操作失敗，請重試。',
		successSummary: '複製完成：新增分類 {categories} 個、商品 {products} 個，略過 {skipped} 個，覆蓋 {overwritten} 個。',
		emptyValue: '空',
		fieldNames: {
			price: '價格', image: '圖片', introduce: '介紹', foodSku: '屬性', sort: '排序', recommend: '推薦', specs: '規格'
		},
		languages: { '0': '越南語', '1': '英語', '2': '簡體中文', '3': '繁體中文' }
	},

	payMethod: {
		remarkTitle: '付款方式說明',
		pageTitle: '支付設定',
		methodSectionTitle: '接受的支付方式',
		methodTip: '不勾選任何方式時，將接受全部可用支付方式；平台關閉的方式對買賣雙方同時失效。',
		save: '保存',
		saveSuccess: '保存成功',
		cancel: '取消',
		groupCod: '到付',
		groupCash: '現金',
		groupCard: '信用卡 / Apple Pay',
		groupLinePay: 'LINE Pay',
		groupOffline: '線下轉帳',
		bankSectionTitle: '收款銀行卡',
		bankTip: '付款方僅能看到當前啟用的銀行卡；啟用新卡將自動停用舊卡；線下轉帳需要至少一張啟用的銀行卡。',
		bankName: '銀行名稱',
		accountNo: '銀行帳號',
		accountName: '戶名',
		activeState: '狀態',
		active: '已啟用',
		inactive: '未啟用',
		action: '操作',
		enable: '啟用',
		edit: '編輯',
		delete: '刪除',
		addCard: '新增銀行卡',
		editCard: '編輯銀行卡',
		pleaseSelectBank: '請選擇銀行',
		deleteConfirm: '確定刪除該銀行卡嗎？',
		tip: '提示',
		cashScopeHint: '僅自取、堂食訂單可用',
		notReadyTip: '未就緒的支付方式勾選後用戶端也不會顯示；信用卡 / LINE Pay 需聯繫平台開通憑證，線下轉帳需先新增並啟用銀行卡。',
		notReadyTag: '未就緒',
	},
	selfDelivery: {
	menu: '自配送設定',
	pageTitle: '自配送設定',
	effectTip: '該設定對旗下所有攤位統一生效：命中時段的外送訂單不進入騎手接單池，由夜市自行配送；未開啟或未命中時段的訂單仍由騎手正常配送。',
	enableSwitch: '開啟自配送',
	modeLabel: '配送模式',
	modeAllDay: '全天自配送',
	modeCustom: '自訂時段',
	customTip: '按星期設定時段；時段含開始時刻、不含結束時刻',
	addRange: '新增時段',
	removeRange: '刪除',
	startTime: '開始時間',
	endTime: '結束時間',
	monday: '週一',
	tuesday: '週二',
	wednesday: '週三',
	thursday: '週四',
	friday: '週五',
	saturday: '週六',
	sunday: '週日',
	saveBtn: '儲存',
	saveSuccess: '儲存成功',
	loadFail: '載入設定失敗',
	saveFail: '儲存失敗',
	invalidRange: '存在不完整的時段，或結束時間未晚於開始時間',
	noRangeTip: '自訂模式下至少需要設定一個時段',
	freightBilling: '自配送運費'
	}
}
